import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { FacebookPixelProvider } from './context/FacebookPixelContext';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Admin from './components/Admin';
import { useFacebookPixelManager } from './hooks/useFacebookPixelManager';
import './App.css';
import './components/ErrorBoundary.css';

// Google Tag Manager scripts
declare global {
  interface Window {
    dataLayer: any[];
    fbq: any;
    gtag: any;
  }
}

const AppContent: React.FC = () => {
  // Initialize Facebook Pixel management
  useFacebookPixelManager();

  React.useEffect(() => {
    // Initialize dataLayer before GTM
    window.dataLayer = window.dataLayer || [];

    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MMFSKDXB');
    `;
    document.head.appendChild(gtmScript);
  }, []);

  return (
    <ErrorBoundary>
      {/* GTM noscript */}
      <noscript>
        <iframe 
          src="https://www.googletagmanager.com/ns.html?id=GTM-MMFSKDXB"
          height="0" 
          width="0" 
          style={{display: 'none', visibility: 'hidden'}}
        />
      </noscript>
      
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

function App() {
  return (
    <FacebookPixelProvider>
      <AppContent />
    </FacebookPixelProvider>
  );
}

export default App;
